<template>
    <div v-loading="dataLoading">
        <template v-if="data">
            <div class="group">
                <div class="page-group-title"><span>用户信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col><span class="color-info">用户身份: </span>{{$userType.get(data.userType)}}</el-col>
                        <el-col><span class="color-info">用户ID: </span>{{data.id}}</el-col>
                        <el-col><span class="color-info">用户名称: </span>{{data.name}}</el-col>
						<el-col><span class="color-info">创建来源: </span>{{data.source}}</el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col>
                            <span class="color-info">收款联系人姓名: </span>{{data.userName}} 
                            <span v-if="data.beforeUserName" class="color-danger">(之前的内容: {{data.beforeUserName}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">收款联系人手机: </span>{{data.userTelephone}} 
                            <span v-if="data.beforeUserTelephone" class="color-danger">(之前的内容: {{data.beforeUserTelephone}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">收款联系人邮箱: </span>{{data.userEmail}} 
                            <span v-if="data.beforeUserEmail" class="color-danger">(之前的内容: {{data.beforeUserEmail}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">通讯地址: </span>{{data.address}} 
                            <span v-if="data.beforeAddress" class="color-danger">(之前的内容: {{data.beforeAddress}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">银行: </span>{{data.bankType == 0 ? data.bankName : '中国大陆以外'}}
                            <span v-if="data.beforeBank" class="color-danger">(之前的内容: {{data.beforeBank}})</span>
                        </el-col>
                        <el-col v-if="data.bankType == 0 ">
                            <span class="color-info">开户网点: </span>{{data.bankAddress}} 
                            <span v-if="data.beforeBankAddress" class="color-danger">(之前的内容: {{data.beforeBankAddress}})</span>
                        </el-col>
						<el-col v-if="data.bankType == 1 ">
						    <span class="color-info">银行名称: </span>{{data.bankAddress}} 
						    <span v-if="data.beforeBankAddress" class="color-danger">(之前的内容: {{data.beforeBankAddress}})</span>
						</el-col>
                        <el-col v-if="data.bankType == 0 ">
                            <span class="color-info">卡号: </span>{{data.bankCardId}} 
                            <span v-if="data.beforeBankCardId" class="color-danger">(之前的内容: {{data.beforeBankCardId}})</span>
                        </el-col>
						<el-col v-if="data.bankType == 1 ">
						    <span class="color-info">收款银行代码: </span>{{data.bankCardId}} 
						    <span v-if="data.beforeBankCardId" class="color-danger">(之前的内容: {{data.beforeBankCardId}})</span>
						</el-col>
                        <el-col>
                            <span class="color-info">账户名: </span>{{data.bankAccount}} 
                            <span v-if="data.beforeBankAccount" class="color-danger">(之前的内容: {{data.beforeBankAccount}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">账户性质: </span>{{accountType.get(data.accountType)}} 
                            <span v-if="data.beforeAccountType" class="color-danger">(之前的内容: {{accountType.get(data.beforeAccountType)}})</span>
                        </el-col>
						<el-col>
							<span class="color-info">企业类型: </span>{{data.businessType == 1 ? '股份有限公司' : '有限责任公司（自然人投资或控股）'}}
							<span v-if="data.beforeBusinessType == 0 || data.beforeBusinessType == 1 " class="color-danger">(之前的内容: {{data.beforeBusinessType == 1 ? '股份有限公司' : '有限责任公司（自然人投资或控股）'}})</span>
						</el-col>
						<el-col>
							<span class="color-info">注册地址: </span>{{data.registeredAddress}} 
							<span v-if="data.beforeRegisteredAddress" class="color-danger">(之前的内容: {{data.beforeRegisteredAddress}})</span>
						</el-col>
						<el-col>
							<span class="color-info">注册资本: </span>{{data.registeredCapitalStr}} 万元
							<span v-if="data.beforeRegisteredCapitalStr" class="color-danger">(之前的内容: {{data.beforeRegisteredCapitalStr}} 万元)</span>
						</el-col>
						<el-col>
							<span class="color-info">法人代表名称: </span>{{data.corporationName}} 
							<span v-if="data.beforeCorporationName" class="color-danger">(之前的内容: {{data.beforeCorporationName}} )</span>
						</el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col v-if="data.accountType == 2">
                            <span class="color-info">证件类型: </span>{{data.accountIdName}} 
                            <span v-if="data.beforeAccountIdName" class="color-danger">(之前的内容: {{data.beforeAccountIdName}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">{{data.accountType == 1 ? '营业执照编号' : '证件号码'}}: </span>{{data.userID}} 
                            <span v-if="data.beforeUserID" class="color-danger">(之前的内容: {{data.beforeUserID}})</span>
                        </el-col>
                        <el-col>
                            <span class="color-info">{{data.accountType == 1 ? '营业执照' : '证件照片'}}: </span> 
                            <span v-if="data.accountPic">
                                <span v-for="(item,index) in data.accountPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.accountPic.split(',')"	></el-image>
                                </span>
                            </span>
                            <span v-if="data.beforeAccountPic">
                                <span class="color-danger">之前的内容:</span>
                                <span v-for="(item,index) in data.beforeAccountPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.beforeAccountPic.split(',')"	></el-image>
                                </span>
                            </span>
                        </el-col>
                        <el-col v-if="data.accountType == 1">
                            <span class="color-info">开户许可证: </span> 
                            <span v-if="data.otherPic">
                                <span v-for="(item,index) in data.otherPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.otherPic.split(',')"	></el-image>
                                </span>
                            </span>
                            <span v-if="data.beforeOtherPic">
                                <span class="color-danger">之前的内容:</span>
                                <span v-for="(item,index) in data.beforeOtherPic.split(',')" :key="index" class="img">
                                    <el-image :src="item" fit="cover" :preview-src-list="data.beforeOtherPic.split(',')"	></el-image>
                                </span>
                            </span>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>状态信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col>
                            <span class="color-info">状态性质: </span>{{data.character == 1 ? '初次提交' : '二次提交'}} 
                        </el-col>
                        <el-col>
                            <span class="color-info">提交审核时间: </span>{{data.createTime}} 
                        </el-col>
                        <el-col>
                            <span class="color-info">审核状态: </span>{{status.get(data.status)}} 
                        </el-col>
                        <el-col>
                            <span class="color-info">寄送状态: </span>{{data.sendStatus == 1 ? '待发出' : data.sendStatus == 2 ? '已发出' : '已寄回'}} 
                        </el-col>
                        <el-col v-if="data.sendTime">
                            <span class="color-info">发出时间: </span>{{data.sendTime}} 
                        </el-col>
                        <el-col v-if="data.mailCompany">
                            <span class="color-info">快递公司: </span>{{data.mailCompany}} 
                        </el-col>
                        <el-col v-if="data.mailNo">
                            <span class="color-info">运单号: </span>{{data.mailNo}} 
                        </el-col>
                        <el-col v-if="data.backTime">
                            <span class="color-info">寄回时间: </span>{{data.backTime}} 
                        </el-col>
                    </el-row>
                </el-card>
            </div>
        </template>
        <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="data && data.character == 2 && data.sendStatus == 1 && $utils.have('/activity/receivables/directUpdate')" type="primary" @click="$refs.directUpdate.show(data,3)">次要修改,直接更新</el-button>
            <el-button v-if="data && data.sendStatus == 1 && $utils.have('/activity/receivables/confirmSend')" type="primary" @click="confirmSend">确认已发出</el-button>
            <el-button v-if="data && data.sendStatus == 2 && $utils.have('/activity/receivables/message')" type="primary" @click="message">再次短信提醒</el-button>
            <template v-if="data && $utils.have('/activity/receivables/audit')">
                <el-button v-if="data.sendStatus == 3" @click="$refs.directUpdate.show(data,1)" type="success">通过</el-button>
                <el-button v-if="data.status == 1 || data.status == 3" @click="$refs.directUpdate.show(data,2)" type="danger">拒绝</el-button>
            </template>
        </div>

        <DirectUpdate ref="directUpdate" @onUpdate="goBack" :id="id"></DirectUpdate>

    </div>
</template>

<script>
import DirectUpdate from './components/directUpdate';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{DirectUpdate},
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/finance/activity/receivables/audit/list',
            data:null,
            character: this.$route.query.character,
        }
    },
    computed:{
        accountType(){
            return new Map([
                [1,'企业'],[2,'个人']
            ])
        },
        status(){
            return new Map([
                [1,'待审核'],
                [2,'已通过'],
                [3,'已拒绝'],
            ])
        },
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/receivables/getDetailInfo",
                params: { id: parseInt(this.id),character: this.character},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //确认发出
        confirmSend(){
            const _msg = `确认已经将电子版合同文件发到了对方邮箱：${this.data.userEmail}`;
            this.$confirm(_msg, '确认已发出', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: '/activity/receivables/confirmSend',
                    method: 'POST',
                    params: {id:this.id,}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataDetail();
                    }else{
                        this.$message.error(msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('操作失败');
                }).finally(() => {
                    
                });
            }).catch(() => {})
        },
        //再次短信提醒
        message(){
            const _msg = '确定再发一次短信通知对方处理合同相关事务？';
            this.$confirm(_msg, '再次短信提醒', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: '/activity/receivables/message',
                    method: 'POST',
                    params: {id:this.id,}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataDetail();
                    }else{
                        this.$message.error(msg || '操作失败');
                    }
                }).catch(() => {
                    this.$message.error('操作失败');
                }).finally(() => {
                    
                });
            }).catch(() => {})
        }
    }
}
</script>
<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
        span{
            vertical-align: top;
        }
    }
    .img{
        margin: 8px 10px 0px 2px;
        display: inline-block;
        .el-image{
            width: 120px;
            height: 120px;
        }
    }
}
</style>